import React, { useState, useEffect } from 'react';
import userAvatar from '../assets/hinhnguoi.png';
import logoImg from '../assets/logo.png';

const Sidebar = ({ activeId = 'spaces', onLogout, onNavClick }) => {
  const [userInfo, setUserInfo] = useState({
    name: 'User',
    email: ''
  });

  // Load user info from localStorage
  useEffect(() => {
    const loadUserInfo = () => {
      const user = localStorage.getItem('user');
      if (user) {
        try {
          const userData = JSON.parse(user);
          setUserInfo({
            name: userData.name || 'User',
            email: userData.email || ''
          });
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
    };

    loadUserInfo();

    // Listen for storage changes (when user updates profile)
    const handleStorageChange = (e) => {
      if (e.key === 'user') {
        loadUserInfo();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for custom event when profile is updated
    window.addEventListener('userProfileUpdated', loadUserInfo);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userProfileUpdated', loadUserInfo);
    };
  }, []);

  const menuItems = [
    { id: 'spaces', label: 'Spaces', icon: <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /> },
    { id: 'rooms', label: 'Rooms', icon: <path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z" /> },
    { id: 'devices', label: 'Devices', icon: <path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M12 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" /> },
    { id: 'members', label: 'Members', icon: <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm14 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /> },
    { id: 'stats', label: 'Statistics', icon: <path d="M18 20V10M12 20V4M6 20v-6" /> },
  ];

  const handleNavClick = (itemId) => {
    if (onNavClick) {
      onNavClick(itemId);
    }
  };

  // Get first letter of name for avatar
  const getInitial = () => {
    return userInfo.name ? userInfo.name.charAt(0).toUpperCase() : 'U';
  };

  return (
    <div className="sidebar">
      <div className="sidebar-top">
        <div className="brand-logo">
          <img src={logoImg} alt="SmartHouse" />
        </div>
        <div className="user-mini-profile">
          <div className="mini-avatar-initial">
            {getInitial()}
          </div>
          <div className="user-info">
            <span className="welcome-text">Welcome home,</span>
            <span className="user-name">{userInfo.name}</span>
          </div>
        </div>
        <nav className="nav-menu">
          {menuItems.map((item) => (
            <div 
              key={item.id} 
              className={`nav-item ${item.id === activeId ? 'active' : ''}`}
              onClick={() => handleNavClick(item.id)}
              style={{ cursor: 'pointer' }}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                {item.icon}
              </svg>
              <span>{item.label}</span>
            </div>
          ))}
        </nav>
      </div>
      <div className="sidebar-bottom">
        <div 
          className={`nav-item ${activeId === 'profile' ? 'active' : ''}`}
          onClick={() => handleNavClick('profile')}
          style={{ cursor: 'pointer' }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.38a2 2 0 0 0-.73-2.73l-.15-.1a2 2 0 0 1-1-1.72v-.51a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/></svg>
          <span>Profile & Settings</span>
        </div>
        <div className="nav-item logout" onClick={onLogout}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          <span>Log out</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;